export default "__VITE_ASSET__D524ZizI__"